((window, document) => {
  'use strict';

  let widget = null
    , number_element = null
    , max = 100
    , overall_max = 0
    , display_max
    , value = 0
    , gauge = null
    , ws = null;

  const pre_init = () => {

    // check for realtime widget.
    widget = document.getElementById('vodl-realtime-users');

    if (null !== widget && widget.classList.contains('pre-init')) {
      init( widget );
    } else {
      // Initialize event listener for lazy realtime widget.
      window.addEventListener('newPage', lazy_init, false);
    }
  };

  const lazy_init = () => {

    // re-check for widget after new page was loaded.
    widget = document.getElementById('vodl-realtime-users');

    if (null !== widget && widget.classList.contains('pre-init')) {
      init(widget);
    }
  };

  const init = (widget) => {

    // initial values - read out from data attributes.
    number_element = widget.querySelector('.vodl-realtime__label-number');
    max = parseInt(widget.getAttribute('data-max'));
    overall_max = parseInt(widget.getAttribute('data-overall-max'));
    display_max = parseInt(widget.getAttribute('data-display-max'));
    value = parseInt(widget.getAttribute('data-value'));

    const gauge_id = 'vodl-gauge';
    const gauge_color = widget.getAttribute('data-color'); // TODO: add class to gauge level for css styling
    const socket_url = widget.getAttribute('data-url');

    // initialize gauge with initial values.
    gauge = new JustGage({
      id: gauge_id,
      value: value,
      min: 0,
      max: max,
      label: '',
      gaugeWidthScale: 1.5,
      counter: true,
      levelColors: [gauge_color],
      hideMinMax: true,
      hideValue: true,
      relativeGaugeSize: true,
      pointer: true,
      pointerOptions: {
        toplength: 10,
        bottomlength: 30,
        bottomwidth: 4,
      },
    });

    try {

      // open web socket and read out data.
      //ws = new WebSocket('wss://realtime-data-proxy-wss-realtime-data-proxy.angry-swirles.lb.russmedia.com');
      ws = new WebSocket(socket_url);
      ws.onmessage = socket_receive;
      ws.onerror = socket_error;
      ws.onopen = socket_open;
      ws.onclose = socket_close;

    } catch (exception) {
      console.error(exception);
    }

    // Initialized - remove lazy stuff.
    widget.classList.remove('pre-init');
    window.removeEventListener('newPage', lazy_init, false);
  };

  // read out data and change widget values.
  const socket_receive = (e) => {
    let data = JSON.parse(e.data);

    if (data.value <= 500 || data.value >= display_max) {
      widget.style.display = 'none';
      return;
    }

    animate_counter(number_element, value, data.value, 500);
    value = data.value;

    // refresh max if neccessary
    if (data.max > value) {
      refresh_max(data.max, value);
    }

    if (data.max <= value) {
      max = value;
      refresh_max(max, value);
    }
  };

  const refresh_max = (max, value) => {
    if (overall_max > 0) {
      if (overall_max > max) {
        (value >= (max * 0.95)) ? gauge.refresh(max, (max * 1.05 )) : gauge.refresh(value, max);
      } else {
        (value >= (overall_max * 0.95)) ? gauge.refresh(overall_max, (overall_max * 1.05)) : gauge.refresh(value, overall_max);
      }
    } else {
      gauge.refresh(value, max);
    }
  };

  // log on web socket error and close connection.
  const socket_error = (e) => {
    console.log('vodl-realtime - WebSocket error ' + e);
    ws.close();
    widget.style.display = 'none';
  };

  // log when connection opens.
  const socket_open = () => {
    console.log('vodl-realtime - WebSocket - open connection ...');
  };

  // log when connection closes.
  const socket_close = () => {
    console.log('vodl-realtime - WebSocket - close connection.');
  };

  // use a nice animation.
  const animate_counter = (counter, from, to, duration) => {

    let range = Math.abs(from - to);

    // no timer shorter than 50ms (not really visible any way)
    let minTimer = 50;
    // calc step time to show all interediate values
    let stepTime = Math.abs(Math.floor(duration / range));

    // never go below minTimer
    stepTime = Math.max(stepTime, minTimer);

    // get current time and calculate desired end time
    let startTime = new Date().getTime();
    let endTime = startTime + duration;
    let timer;

    const run = () => {
      const now = new Date().getTime();
      let remaining = Math.max((endTime - now) / duration, 0);
      let value = Math.round(to - (remaining * range));
      if (1000 < value) {
        counter.innerHTML = (value/1000).toFixed(3);
      } else {
        counter.innerHTML = value;
      }
      if (value == to) {
        clearInterval(timer);
      }
    };

    timer = setInterval(run, stepTime);
    run();
  };

  document.addEventListener('DOMContentLoaded', pre_init);

})(window, document);
